import * as Yup from 'yup';

interface ValidationOptions {
  // A dueDate matching this value bypasses "must be in the future" — lets users save unchanged past dates on existing schedules.
  initialDueDate?: Date | null;
}

export const createBaseValidationSchema = ({ initialDueDate }: ValidationOptions = {}) =>
  Yup.object().shape({
    name: Yup.string().required('Name is required'),
    template: Yup.object().nullable().required('Template is required'),
    assignees: Yup.array().test(
      'has-a-performer',
      'At least one assignee or group is required',
      (value) => (value?.length ?? 0) > 0
    ),
    startDate: Yup.date().nullable().required('Start date is required'),
    dueDate: Yup.date()
      .nullable()
      .required('Due date is required')
      .test('in-the-future', 'Due date must be in the future', (value) => {
        if (!value) return true;
        if (initialDueDate && value.getTime() === initialDueDate.getTime()) return true;
        return value.getTime() > Date.now();
      })
      .when('startDate', (startDate, schema) =>
        startDate[0] ? schema.min(new Date(startDate[0].getTime() + 1), 'Due date must be after start date') : schema
      ),
  });

export const createValidationSchema = (options: ValidationOptions = {}) =>
  createBaseValidationSchema(options).shape({
    frequency: Yup.string()
      .required('Frequency is required')
      .oneOf([
        'one-off',
        'everyday',
        'weekday',
        'weekly',
        'monthly-date',
        'monthly',
        'every-3-months',
        'every-6-months',
        'yearly',
        'every-3-years',
      ]),
  });
